import { AxiosPromise, AxiosStatic } from "axios";
import { TAuthUserType, TPostUser } from "../types";

const postUser =
  (serverURL: string, appAxios: AxiosStatic, token: string) =>
  async ({ authUserId, namespace }: TPostUser): AxiosPromise<TAuthUserType> =>
    await appAxios.post(
      `${serverURL}/admin/users`,
      { authUserId, namespace },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );

export default postUser;
